import { Link } from "react-router-dom";
import { ShoppingBag, Tag, Store, ChevronRight, ClipboardList } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

function MarketCard({ to, icon: Icon, title, sub, testId, tone }) {
  return (
    <Link
      to={to}
      className={`group block rounded-2xl border border-app-border bg-white p-6 sm:p-8 transition-all hover:-translate-y-0.5 hover:shadow-md ${tone}`}
      data-testid={testId}
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-olive/10 text-olive flex items-center justify-center shrink-0">
          <Icon className="w-6 h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-heading text-xl font-semibold text-espresso">{title}</h2>
          <p className="text-sm text-espresso/60 mt-1">{sub}</p>
        </div>
        <ChevronRight className="w-5 h-5 text-espresso/40 rtl:rotate-180 group-hover:translate-x-0.5 rtl:group-hover:-translate-x-0.5 transition-transform" />
      </div>
    </Link>
  );
}

export default function MarketPage() {
  const { t } = useI18n();
  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="market-page">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-espresso flex items-center gap-2">
          <Store className="w-7 h-7 text-olive" />
          {t("market.title")}
        </h1>
        <p className="text-sm text-espresso/70 mt-1">{t("market.sub")}</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <MarketCard to="/market/sell" icon={Tag} title={t("market.selling")} sub={t("market.selling_sub")} testId="market-sell-card" />
        <MarketCard to="/market/buy" icon={ShoppingBag} title={t("market.buying")} sub={t("market.buying_sub")} testId="market-buy-card" />
      </div>
      <MarketCard to="/market/mine" icon={ClipboardList} title={t("market.mine")} sub={t("market.mine_sub")} testId="market-mine-card" tone="border-olive/40" />
    </div>
  );
}
